/* eslint-disable */
function amorMonths(payment, interestRate, loanBalance, lengthMonths) {

  const results = [];

  let interest = 0;
  let principal = 0;

  // Calculate total Balance
  let totalBalance = loanBalance;
  let interestTotal = 0;

  for (let i = 1; i <= lengthMonths; i++) {

    interest = interestRate * totalBalance;
    principal = payment - interest;

    totalBalance = parseFloat(totalBalance - principal);

    if (totalBalance < 0) {
      totalBalance = 0;
    }

    interestTotal += interest;

    results.push({
      principal: Number(principal.toFixed(2)),
      interest: Number(interest.toFixed(2)),
      interestTotal: Number(interestTotal.toFixed(2)),
      totalBalance: Number(totalBalance.toFixed(2)),
    });

  }

  return results;

}

export default amorMonths;
